<template>
  <li role="presentation">
    <button
      v-bind="$attrs"
      class="dropdown-item"
      :class="[buttonClass,
               {
                 [activeClass]: active,
                 [`text-${variant}`]: variant && !(active || disabled)
               }
      ]"
      role="menuitem"
      href="#"
      target="_self"
      @click="onClick"
    >
      <slot />
    </button>
  </li>
</template>

<script>
export default {
  name: 'BDropdownItemButton',
  inject: {
    getDropdownParent: { default: () => () => null }
  },
  inheritAttrs: false,
  props: {
    active: Boolean,
    activeClass: {
      type: String,
      default: 'active'
    },
    buttonClass: {
      type: [String, Array, Object],
      default: 'btn'
    },
    disabled: Boolean,
    variant: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  computed: {
    dropdownParent() {
      return this.getDropdownParent()
    }
  },
  methods: {
    closeDropdown() {
      setTimeout(() => {
        if (this.dropdownParent) {
          this.dropdownParent.hide(true)
        }
      }, 16)
    },
    onClick(e) {
      this.$emit('click', e)
      this.closeDropdown()
    }
  }
}
</script>
